import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BulkVendorAddition from '../components/bulkVendorAddition';
import * as BulkVendorAction from '../actions/bulkVendorAction';
import * as authActions from '../actions/authActions';
import * as SnackBarAction from '../actions/snackbarAction';

function mapStateToProps(state) {
  return {
    ...state.BulkVendorReducer,
    userInfo: state?.Chargecard?.userInfo,
    submitStatus: state?.BulkVendorReducer.submitStatus
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...BulkVendorAction,
      ...authActions,
      ...SnackBarAction,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(BulkVendorAddition);
